import styled from 'styled-components'

export const BankSpinner = styled.p`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid transparent;
  margin-left: 8px;
  position: absolute;
  right: 17px;
  bottom: 2px;
  /* background-color:red; */

  border-top-color: #074ee6;
  /* border-top-color: red; */

  animation: spin 1s linear infinite;
  -webkit-animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
`

export const BankDetailsSpinner = styled(BankSpinner)`
  border: 4px solid transparent;
  border-top-color: white;
  position: absolute;
  right: 110px;

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    right: 60px;
    top: 20px;
  }

  /* top: 10px; */
`
